<script>

export default {
    props: ['tokenPurchase'],
    data() {
        return {
            loading: false,
            loaded: false,
            errors: {
                terms: null
            },
            success: false,
        }
    },

    methods: {
        submit() {
            this.loading = true;
            axios.post('/token-purchases/' + this.tokenPurchase.id + '/mint').then(response => {
                this.$emit('minted', response.data.data);
                this.$toast.success(this.$t('token_purchases.messages.tokens_sent'));
            }).catch(error => {
            }).finally(() => {
                this.loading = false;
            })
        },
        close() {
            this.$emit('close');
        }
    }
};
</script>

<template>
    <section>
        <div class="modal is-active">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ $t('token_purchases.labels.send_tokens') }}</p>
                    <button class="delete" aria-label="close" @click="close"></button>
                </header>
                <div class="modal-card-body">
                    <p class="mb-4">
                        {{ $t('token_purchases.fields.token_amount.name') }}: <strong>{{ tokenPurchase.token_amount }}</strong>
                    </p>
                    <p>
                        {{ $t('token_purchases.fields.company.name') }}: <strong>{{ tokenPurchase.company_name }}</strong>
                    </p>

                </div>
                <footer class="modal-card-foot">
                    <div class="buttons">
                        <b-button @click="submit()" d:disabled="loading"
                                :loading="loading"
                                type="is-success">
                            {{ $t('actions.send') }}
                        </b-button>
                        <b-button @click="close">
                            {{ $t('actions.cancel') }}
                        </b-button>
                    </div>
                </footer>
            </div>
        </div>
    </section>
</template>
<style scoped>
.modal-card {
    min-height: 300px;
}
</style>
